import { render, staticRenderFns } from "./UserEditorLayout.vue?vue&type=template&id=395e8754&"
import script from "./UserEditorLayout.vue?vue&type=script&lang=js&"
export * from "./UserEditorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports